import { Component, OnInit, ViewChild } from '@angular/core';
import { ListeComponent } from 'src/app/liste/liste.component';
import { GeneralService } from 'src/app/services/general.service';
import { AvtDialogDeleteComponent } from 'src/app/avt-dialog-delete/avt-dialog-delete.component';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-fournisseur',
  templateUrl: './fournisseur.component.html',
  styleUrls: ['./fournisseur.component.scss'],
})
export class FournisseurComponent implements OnInit {
  @ViewChild('frmAjout', { static: false }) frmAjout;

  @ViewChild('listeConmponent', { static: false })
  listeConmponent: ListeComponent;
  @ViewChild('listeDetailConmponent', { static: false })
  listeDetailConmponent: ListeComponent;
  exist: boolean = true;

  dsFournisseur;
  dsVille;
  listeFournisseurs = [];
  listeTypeEvennement = [];
  listVilles = [];
  columnsFournisseur;

  listBtn = [
    // {name:"consulter",class:"colorGreen",text:"Consulter",disabled : false,icon:"search"},
    {
      name: 'ajouter',
      class: 'colorGreen',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'modifier',
      class: 'colorBlue',
      text: 'Modifier',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];

  isModifForunisseur;

  stateCtrl = new FormControl();
  filteredStates: Observable<any[]>;

  prestationCtrl = new FormControl();
  filteredPrestation: Observable<any[]>;
  constructor(public generalService: GeneralService) {
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) =>
        state ? this._filterStates(state) : this.listVilles.slice()
      )
    );

    this.filteredPrestation = this.prestationCtrl.valueChanges.pipe(
      startWith(''),
      map((state) =>
        state ? this._filterPrestation(state) : this.listeTypeEvennement.slice()
      )
    );
  }

  ngOnInit(): void {
    this.getColonneFournisseur();
    this.getAllListFournisseur();
    this.getDsVille();
    this.getDsFournisseur();
    this.getTypeEvenements();
    this.getAllCities();
    this.setUpGlobalvalues();
  }

  init() {
    this.typeEvent = null;
    this.ville = null;
  }
  setUpGlobalvalues() {
    this.prefix_TiersCode = '';
    this.info_message = '';
    this.alert_message = { type: '', text: '' };
    this.selectedPrestation = null;
    this.stateCtrl.reset();
    this.prestationCtrl.reset();
  }

  copyDsFournisseur;
  getDsFournisseur() {
    this.generalService.getDS('tiers').subscribe((res: any) => {
      console.log(res);
      this.copyDsFournisseur = res;
      this.dsFournisseur = res;
    });
  }
  getDsVille() {
    this.generalService.getDS('Villes').subscribe((res: any) => {
      console.log(res);
      this.dsVille = res;
    });
  }

  addVille() {
    if (this.dsVille?.Villes[0].Ville)
      this.generalService.postDs(this.dsVille).subscribe(
        (res: any) => {
          this.getDsVille();
          this.getAllCities();
          this.generalService.dialogSuccess('Ville ajouté!', true);
        },
        () => {
          this.generalService.dialogSuccess('Erreur ajout ville!', false);
        }
      );
    else {
      this.generalService.dialogSuccess('veuillez entrer votre ville!', false);
    }
  }

  getTypeEvenements() {
    this.generalService
      .rechercheTable2('Api_listeTypeEvennement')
      .subscribe((res: any) => {
        console.log(res);

        this.listeTypeEvennement = res.filter((e) => e.TravelD_TypeEvent != 2);
      });
  }

  getAllCities() {
    this.generalService.rechercheTable2('apiville').subscribe((res: any) => {
      this.listVilles = res;
    });
  }

  columnsFournisseurApercu;
  getColonneFournisseur() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=batfour')
      .subscribe((data) => {
        if (data && data.TableRD.length > 0) this.columnsFournisseur = data;
        this.columnsFournisseurApercu = this.columnsFournisseur.TableRD.slice(
          1,
          this.columnsFournisseur.TableRD.length - 1
        );
      });
  }
  getAllListFournisseur() {
    this.generalService
      .rechercheTable2('batfour1')
      .subscribe((Fournisseurs: any) => {
        this.listeFournisseurs = Fournisseurs;
      });
  }

  output(event) {
    if (event.action == 'clickRow') {
    }
    if (event.action == 'clickBtnHeat') {
      if (event.bouton.name == 'ajouter') {
        this.openDialogAjouterOuModifier();
        return;
      }

      if (event.liste.row) {
        if (event.bouton.name == 'modifier') {
          this.modifier(event);
        }
        if (event.bouton.name == 'supprimer') {
          this.supprimer(event);
        }
      } else
        this.generalService.dialogSuccess(
          'Veillez sélectionner une ligne',
          false
        );
    }
    if (event.action == 'dbClick') {
      this.openDialogAjouterOuModifier(event.liste.row, true);
    }
  }

  openDialogAjouterOuModifier(event?, isModif?) {
    if (isModif) {
      this.isModifForunisseur = isModif;
      this.generalService.getDS('tiers', event.Tiers_code).subscribe((res) => {
        console.log(res);
        this.dsFournisseur = res;
        this.prestationCtrl.setValue(
          this.listeTypeEvennement.find(
            (e) =>
              e.TravelD_TypeEvent == this.dsFournisseur.Tiers[0].Tiers_Stat5
          )
        );
        this.stateCtrl.setValue(this.dsFournisseur.Tiers[0].Tiers_Ville);
      });
    } else {
    }
    this.generalService.dialog.open(this.frmAjout, {
      disableClose: true,
    });
  }

  close() {
    this.generalService.dialog.closeAll();
    this.generalService.dialog.afterAllClosed.subscribe(() => {});
    //this.getDsFournisseur();
  }

  ajouterOuModifierLigneFournisseur() {
    if (!this.isModifForunisseur) {
      this.dsFournisseur.Tiers[0].Tiers_codeF = 1;
      this.dsFournisseur.Tiers[0].Tiers_Type = '02';
      console.log(this.dsFournisseur);
      let Copy_data_TiersObj_before_add = Object.assign(
        {},
        this.dsFournisseur.Tiers[0]
      );
      this.generalService.postDs(this.dsFournisseur).subscribe((res) => {
        console.log('founisseur enregistrer');

        this.close();
        this.getDsFournisseur();
        this.getAllListFournisseur();
        this.setUpGlobalvalues();
        this.generalService.dialogSuccess('Fournisseur Enregistrée!', true);
        if (Copy_data_TiersObj_before_add.Tiers_Stat5 == 1) {
          this.generate_Four_RestorationHotel(Copy_data_TiersObj_before_add);
          this.ajouterOuModifierLigneFournisseur();
        }
      });
    } else {
      this.generalService.postDs(this.dsFournisseur).subscribe((res) => {
        console.log('fournisseur enregistrer');

        this.close();
        this.getDsFournisseur();
        this.getAllListFournisseur();
        this.setUpGlobalvalues();
        this.generalService.dialogSuccess('Fournisseur modifiée!', true);
      });
    }
  }

  modifier(event) {
    if (event && event.liste.row) {
      this.openDialogAjouterOuModifier(event.liste.row, true);
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }

  supprimer(event) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        this.exist = false;
        this.listBtn.forEach((btn) => {
          btn.disabled = true;
        });

        console.log(event.liste.row);

        if (this.generalService.isNotEmpty(event.liste.row.Tiers_code)) {
          console.log(event.liste.dataSource.length);

          var deleteFn = this.generalService.delete(
            event.liste.row.Tiers_code,
            'Tiers'
          );
          if (deleteFn != null) {
            deleteFn.subscribe(
              (data) => {
                this.listeConmponent.dataSource.splice(
                  this.listeConmponent.rowIndex,
                  1
                );
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.exist = true;
                this.listBtn.forEach((btn) => {
                  btn.disabled = false;
                });
                this.getAllListFournisseur();
              },
              () => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
              }
            );
          }
        }
      }
    });
  }

  // ! **************************
  prefix_TiersCode = '';
  info_message = '';
  alert_message = { type: '', text: '' };
  selectedPrestation;
  typeEvennementChange(event?) {
    console.log(event);
    this.selectedPrestation = event;
    this.dsFournisseur.Tiers[0].Tiers_Stat5 =
      this.selectedPrestation.TravelD_TypeEvent;

    switch (event.TravelD_TypeEvent) {
      case 0:
        this.prefix_TiersCode = 'D';
        break;
      case 1:
        this.prefix_TiersCode = 'H';
        this.info_message =
          'cette option va générer automatiquement la prestation restauration hôtel.';
        break;
      case 3:
        this.prefix_TiersCode = 'B';
        break;
      case 5:
        this.prefix_TiersCode = 'S';
        break;
      case 6:
        this.prefix_TiersCode = 'EX';
        break;
      case 7:
        this.prefix_TiersCode = 'G';

        break;
      case 8:
        this.prefix_TiersCode = 'R';
        break;

      default:
        this.prefix_TiersCode = 'B';

        break;
    }

    if (event.TravelD_TypeEvent !== 1) {
      this.info_message = '';
    }

    const nextCode_after_lastCode = this.get_nextCode_after_LastTiersCode(
      this.prefix_TiersCode
    );
    this.dsFournisseur.Tiers[0].Tiers_code = nextCode_after_lastCode;
    this.check_TiersCode_validity(this.prefix_TiersCode);
  }

  getLastTiersCode(prefix: string): string | undefined {
    const filteredData = this.listeFournisseurs
      .filter((item) => item.Tiers_code.startsWith(prefix))
      .sort((a, b) => {
        const aNumericPart = parseInt(a.Tiers_code.slice(prefix.length), 10);
        const bNumericPart = parseInt(b.Tiers_code.slice(prefix.length), 10);

        if (isNaN(aNumericPart) || isNaN(bNumericPart)) {
          return a.Tiers_code.localeCompare(b.Tiers_code);
        }

        return bNumericPart - aNumericPart;
      });

    return filteredData.length > 0 ? filteredData[0].Tiers_code : undefined;
  }

  get_nextCode_after_LastTiersCode(prefix: string): string | undefined {
    const lastCode = this.getLastTiersCode(prefix);
    console.log(lastCode);

    if (lastCode) {
      const lastNumber = parseInt(lastCode.slice(prefix.length), 10);
      const nextNumber = lastNumber + 1;
      const nextCode =
        prefix + nextNumber.toString().padStart(lastCode.length - 1, '0');
      return nextCode;
    }

    return undefined;
  }

  check_TiersCode_validity(prefix: string) {
    const nextCode_after_lastHotelCode =
      this.get_nextCode_after_LastTiersCode(prefix);
    if (this.dsFournisseur.Tiers[0].Tiers_code < nextCode_after_lastHotelCode) {
      this.alert_message.type = 'danger';
      this.alert_message.text = 'svp incrémenté le code fournisseur ';
    } else {
      this.alert_message.type = 'succes';
      this.alert_message.text = 'le code fournisseur est valide';
    }
  }

  selectedVille = '';
  typeVilleChange(event?) {
    console.log(event);

    this.selectedVille = event;
    this.dsFournisseur.Tiers[0].Tiers_Ville = this.selectedVille;
  }

  changeMainSelectPrestation(event?) {
    this.filterBy_TypeEvent_Ville(this.typeEvent, this.ville);
  }
  changeMainSelectville(event?) {
    this.filterBy_TypeEvent_Ville(this.typeEvent, this.ville);
  }

  typeEvent;
  ville;
  filterBy_TypeEvent_Ville(TypeEvent, Ville) {
    if ((TypeEvent == 0 || TypeEvent) && Ville) {
      this.generalService
        .rechercheTable2('batfour', TypeEvent + ',' + Ville)
        .subscribe((filtredFour: any) => {
          this.listeFournisseurs = filtredFour;
        });
    }
  }

  private _filterStates(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.listVilles.filter((state) =>
      state.Ville.toLowerCase().includes(filterValue)
    );
  }

  private _filterPrestation(value): any[] {
    console.log(typeof value);
    let filterValue;
    if (typeof value == 'object') filterValue = value['text'].toLowerCase();
    else filterValue = value.toLowerCase();

    return this.listeTypeEvennement.filter((state) =>
      state.text.toLowerCase().includes(filterValue)
    );
  }
  displayFn(prestation?: any): string | undefined {
    return prestation ? prestation.text : undefined;
  }

  //! generate Restoration Hotel after adding Hebergement

  generate_Four_RestorationHotel(data_hebergement) {
    this.dsFournisseur.Tiers[0].Tiers_code =
      this.get_nextCode_after_LastTiersCode('RH');
    this.dsFournisseur.Tiers[0].Tiers_RS = data_hebergement.Tiers_RS;
    this.dsFournisseur.Tiers[0].Tiers_Stat5 = 2;
    this.dsFournisseur.Tiers[0].Tiers_Ville = data_hebergement.Tiers_Ville;
  }
}
